module.exports = __webpack_public_path__ + "img/maya-2-analitico.26ad1773.png";